<template>
  <Drawer
    :title="title"
    :visible="visible"
    @handleOk="handleOk"
    @handleCancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="系统名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="50"
            v-decorator="[
              'systemName',

              { rules: [{ required: true, message: '请输入系统名' }] },
            ]"
            placeholder="请输入系统名"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="系统代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :max-length="50"
            v-decorator="[
              'systemCode',
              { rules: [{ required: true, message: '请输入系统代码' }] },
            ]"
            placeholder="请输入系统代码"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="ip白名单"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['ipWhiteList']"
            placeholder="要支持0/24、ipv6"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="记录日志"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            v-decorator="[
              'isLog',
              { initialValue: false, valuePropName: 'checked' },
            ]"
            checked-children="是"
            un-checked-children="否"
          />
        </a-form-item>
        <a-form-item
          label="是否加密"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            v-decorator="[
              'isEncrypt',
              { initialValue: false, valuePropName: 'checked' },
            ]"
            checked-children="是"
            un-checked-children="否"
            @click="handleEncrypt"
          />
        </a-form-item>
        <div v-show="isShow">
          <a-form-item
            label="加密方式"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-radio-group v-decorator="['encryptWay']">
              <a-radio :value="1"> AES </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            label="加密模式"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-radio-group v-decorator="['encryptModel']">
              <a-radio :value="1"> CTR </a-radio>
            </a-radio-group>
          </a-form-item>
          <!-- <a-form-item
          label="填充方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['fillStyle', { rules: [{ required: false }] }]"
            placeholder="请输入"
          ></a-input>
        </a-form-item> -->
          <a-form-item
            label="加密密匙"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              :max-length="16"
              v-decorator="[
                'encryptSecretKey',
                {
                  rules: [
                    { required: isShow, message: '请输入密钥' },
                    {
                      pattern: /^([A-Z]|[a-z]|[\d])*$/,
                      message: '格式有误只能输入字母及数字',
                    },
                  ],
                },
              ]"
              placeholder="请输入密钥"
            ></a-input>
          </a-form-item>
        </div>
      </a-form>
    </a-spin>
  </Drawer>
</template>
<script>
import { postAction } from '@/api/manage';
import pick from 'lodash.pick';
import Drawer from '@/components/common/Drawer';
import store from '@/store/';

export default {
  name: 'AuthorizationModal',
  components: {
    Drawer,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      isDisable: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/add',
        edit: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/update',
      },
      isEdit: false,
      recordId: '',
      encryptModel: false,
      encryptWay: false,
      isShow: false,
    };
  },
  created() {},
  methods: {
    edit(record) {
      this.form.resetFields();
      this.visible = true;
      this.isLog = record == 1 ? true : false;
      this.isEncrypt = record.isEncrypt == 1 ? true : false;

      this.isEdit = record && record.id ? true : false;
      this.recordId = record && record.id ? record.id : '';
      this.isShow = this.isEncrypt ? true : false;

      this.$nextTick(() => {
        this.form.setFieldsValue({
          ...record,
          isLog: record.isLog == 1 ? true : false,
          isEncrypt: record.isEncrypt == 1 ? true : false,
        });
      });
    },
    handleOk() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        console.log(values);

        let params = {
          ...values,
          id: this.recordId,
          isLog: values.isLog ? 1 : 0,
          isEncrypt: values.isEncrypt ? 1 : 0,
          userId: store.getters.userInfo.id,
        };
        let url = this.isEdit ? this.url.edit : this.url.add;
        if (!err) {
          postAction(url, params).then((res) => {
            if (res.success) {
              this.visible = false;
              this.$emit('ok');
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form.resetFields();
    },
    // clearChecked(flg) {
    //   if (this.form.getFieldValue(flg)) {
    //     this.form.setFieldsValue({ [flg]: '' });
    //   }
    // },
    handleEncrypt(e) {
      this.isShow = !this.isShow;
      this.form.setFieldsValue({
        encryptWay: e ? 1 : 0,
        encryptModel: e ? 1 : 0,
      });
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
